module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "elevation-5",
    attrs: {
      "value": _vm.drawerState,
      "permanent": !_vm.mobile,
      "temporary": _vm.mobile,
      "width": "300"
    },
    on: {
      "input": _vm.onDrawerInput
    }
  }, [_c('div', {
    staticClass: "left_nav"
  }, [(_vm.preventClickOutside) ? _c('div', {
    staticClass: "prevent_click_outside"
  }) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('info', 'add')) ? _c('div', {
    staticClass: "text-xs-center pt-4 pb-2",
    staticStyle: {
      "background": "#FAFAFA"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisAdicionar'
      }
    }
  }, [_c('v-btn', {
    staticClass: "secondary"
  }, [_vm._v("Cadastrar Imóvel")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "background": "#FAFAFA"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "padding": "9px 16px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "borda_laranja",
    attrs: {
      "placeholder": "Busca",
      "hide-details": "",
      "append-icon": "search",
      "append-icon-cb": _vm.setFiltros
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.texto),
      callback: function($$v) {
        _vm.form.texto = $$v
      },
      expression: "form.texto"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "padding": "9px 16px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "remover_padding mx-0 grey",
    class: {
      'secondary--text': _vm.countFiltros > 0, 'grey--text': _vm.countFiltros === 0
    },
    attrs: {
      "flat": "",
      "disabled": _vm.countFiltros === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.limparFiltros($event)
      }
    }
  }, [_vm._v("Limpar filtros")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": !_vm.filtroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.setFiltros($event)
      }
    }
  }, [_vm._v("Aplicar")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', [(_vm.canShowProprietarioFilter) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Proprietário",
      "items": _vm.proprietarioItems,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.proprietario),
      callback: function($$v) {
        _vm.form.proprietario = $$v
      },
      expression: "form.proprietario"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.canShowProprietarioFilter) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('info', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Tipo",
      "items": _vm.lista.tipo,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.tipo),
      callback: function($$v) {
        _vm.form.tipo = $$v
      },
      expression: "form.tipo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('info', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Estado",
      "items": Object.keys(_vm.lista.uf),
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.uf),
      callback: function($$v) {
        _vm.form.uf = $$v
      },
      expression: "form.uf"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.form.uf.length > 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Cidade",
      "items": Object.keys(_vm.lista.cidade).sort(),
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.cidade),
      callback: function($$v) {
        _vm.form.cidade = $$v
      },
      expression: "form.cidade"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.uf.length > 0) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.form.cidade.length > 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Bairro",
      "items": _vm.lista.bairro,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.bairro),
      callback: function($$v) {
        _vm.form.bairro = $$v
      },
      expression: "form.bairro"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.cidade.length > 0) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Em loteamento",
      "items": _vm.lista.com_loteamento,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.com_loteamento),
      callback: function($$v) {
        _vm.form.com_loteamento = $$v
      },
      expression: "form.com_loteamento"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.form.com_loteamento === 1) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Selecionar loteamento",
      "items": _vm.lista.loteamento,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.loteamento),
      callback: function($$v) {
        _vm.form.loteamento = $$v
      },
      expression: "form.loteamento"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.com_loteamento === 1) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.form.com_loteamento === 1) ? _c('v-list-group', {
    attrs: {
      "no-action": ""
    },
    model: {
      value: (_vm.opcoes.lote),
      callback: function($$v) {
        _vm.opcoes.lote = $$v
      },
      expression: "opcoes.lote"
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Lote e quadra")]), _vm._v(" "), (!_vm.opcoes.lote && (_vm.form.lote.length > 0 || _vm.form.quadra.length > 0)) ? _c('div', {
    staticClass: "selecionados"
  }, [(_vm.form.lote.length > 0) ? [_vm._v("Lote " + _vm._s(_vm.form.lote))] : _vm._e(), _vm._v(" "), (_vm.form.lote.length > 0 && _vm.form.quadra.length > 0) ? [_vm._v(" - ")] : _vm._e(), _vm._v(" "), (_vm.form.quadra.length > 0) ? [_vm._v("Quadra " + _vm._s(_vm.form.quadra))] : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('div', {
    staticClass: "body-2 pt-2"
  }, [_vm._v("Lote")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "lote",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.lote),
      callback: function($$v) {
        _vm.form.lote = $$v
      },
      expression: "form.lote"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "body-2 pt-4"
  }, [_vm._v("Quadra")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "quadra",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.quadra),
      callback: function($$v) {
        _vm.form.quadra = $$v
      },
      expression: "form.quadra"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.com_loteamento === 1) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-list-group', {
    attrs: {
      "no-action": ""
    },
    model: {
      value: (_vm.opcoes.status),
      callback: function($$v) {
        _vm.opcoes.status = $$v
      },
      expression: "opcoes.status"
    }
  }, [(_vm.$hasGranularPermission('status', 'view')) ? _c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Status")]), _vm._v(" "), (!_vm.opcoes.status && _vm.form.status.length > 0) ? _c('div', {
    staticClass: "selecionados"
  }, [_vm._v("\n              " + _vm._s(_vm.form.status.join(', ')) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Vago",
      "color": "secondary",
      "value": "Vago",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.resetarFilhos('Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Com placa",
      "items": _vm.lista.vago_com_placa,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": function($event) {
        _vm.marcarStatus($event, 'Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.vago_com_placa),
      callback: function($$v) {
        _vm.form.vago_com_placa = $$v
      },
      expression: "form.vago_com_placa"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-2 py-2"
  }, [_vm._v("Nível de segurança")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Seguro",
      "color": "secondary",
      "value": "Seguro",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.vago_seguranca),
      callback: function($$v) {
        _vm.form.vago_seguranca = $$v
      },
      expression: "form.vago_seguranca"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Média segurança",
      "color": "secondary",
      "value": "Média segurança",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.vago_seguranca),
      callback: function($$v) {
        _vm.form.vago_seguranca = $$v
      },
      expression: "form.vago_seguranca"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inseguro",
      "color": "secondary",
      "value": "Inseguro",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Vago');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.vago_seguranca),
      callback: function($$v) {
        _vm.form.vago_seguranca = $$v
      },
      expression: "form.vago_seguranca"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "py-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Compromissado",
      "color": "secondary",
      "value": "Compromissado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.resetarFilhos('Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Em dia",
      "color": "secondary",
      "value": "Em dia",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Quitado sem escritura",
      "color": "secondary",
      "value": "Quitado sem escritura",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Com escritura definitiva",
      "color": "secondary",
      "value": "Com escritura definitiva",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inadimplente",
      "color": "secondary",
      "value": "Inadimplente",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inadimplente ajuizado",
      "color": "secondary",
      "value": "Inadimplente ajuizado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Compromissado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.compromissado_condicao),
      callback: function($$v) {
        _vm.form.compromissado_condicao = $$v
      },
      expression: "form.compromissado_condicao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "py-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Locado",
      "color": "secondary",
      "value": "Locado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.resetarFilhos('Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), (_vm.$auth.check('Administrador')) ? _c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Em dia",
      "color": "secondary",
      "value": "Em dia",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_condicao),
      callback: function($$v) {
        _vm.form.locado_condicao = $$v
      },
      expression: "form.locado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inadimplente",
      "color": "secondary",
      "value": "Inadimplente",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_condicao),
      callback: function($$v) {
        _vm.form.locado_condicao = $$v
      },
      expression: "form.locado_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inadimplente ajuizado",
      "color": "secondary",
      "value": "Inadimplente ajuizado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_condicao),
      callback: function($$v) {
        _vm.form.locado_condicao = $$v
      },
      expression: "form.locado_condicao"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Com ação renovatória",
      "items": _vm.lista.locado_acao_renovatoria,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.locado_acao_renovatoria),
      callback: function($$v) {
        _vm.form.locado_acao_renovatoria = $$v
      },
      expression: "form.locado_acao_renovatoria"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-1 mb-3"
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Índice",
      "items": _vm.lista.locado_indice,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.locado_indice),
      callback: function($$v) {
        _vm.form.locado_indice = $$v
      },
      expression: "form.locado_indice"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-1 mb-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-2 pt-2"
  }, [_vm._v("Valor do aluguel (R$)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "locado_valor_minimo",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_valor_minimo),
      callback: function($$v) {
        _vm.form.locado_valor_minimo = $$v
      },
      expression: "form.locado_valor_minimo"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "locado_valor_maximo",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        _vm.marcarStatus($event, 'Locado');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.locado_valor_maximo),
      callback: function($$v) {
        _vm.form.locado_valor_maximo = $$v
      },
      expression: "form.locado_valor_maximo"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "py-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Comodato",
      "color": "secondary",
      "value": "Comodato",
      "hide-details": ""
    },
    on: {
      "change": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "py-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "status_checkbox",
    attrs: {
      "label": "Invadido",
      "color": "secondary",
      "value": "Invadido",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.resetarFilhos('Invadido');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Ocupado irregularmente",
      "color": "secondary",
      "value": "Ocupado irregularmente",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Invadido');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.invadido_condicao),
      callback: function($$v) {
        _vm.form.invadido_condicao = $$v
      },
      expression: "form.invadido_condicao"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Ocupado ajuizado",
      "color": "secondary",
      "value": "Ocupado ajuizado",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.marcarStatus($event, 'Invadido');
        _vm.marcarFiltroAlterado();
      }
    },
    model: {
      value: (_vm.form.invadido_condicao),
      callback: function($$v) {
        _vm.form.invadido_condicao = $$v
      },
      expression: "form.invadido_condicao"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('status', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-list-group', {
    attrs: {
      "no-action": ""
    },
    model: {
      value: (_vm.opcoes.area),
      callback: function($$v) {
        _vm.opcoes.area = $$v
      },
      expression: "opcoes.area"
    }
  }, [(_vm.$hasGranularPermission('area', 'view')) ? _c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Área")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('div', {
    staticClass: "body-2 pt-2"
  }, [_vm._v("Área do terreno (m²)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_terreno_minima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_terreno_minima),
      callback: function($$v) {
        _vm.form.area_terreno_minima = $$v
      },
      expression: "form.area_terreno_minima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_terreno_maxima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_terreno_maxima),
      callback: function($$v) {
        _vm.form.area_terreno_maxima = $$v
      },
      expression: "form.area_terreno_maxima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "body-2 pt-4"
  }, [_vm._v("Área construída (m²)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_construida_minima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_construida_minima),
      callback: function($$v) {
        _vm.form.area_construida_minima = $$v
      },
      expression: "form.area_construida_minima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_construida_maxima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_construida_maxima),
      callback: function($$v) {
        _vm.form.area_construida_maxima = $$v
      },
      expression: "form.area_construida_maxima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "body-2 pt-4"
  }, [_vm._v("Área útil (m²)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_util_minima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_util_minima),
      callback: function($$v) {
        _vm.form.area_util_minima = $$v
      },
      expression: "form.area_util_minima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "name": "area_util_maxima",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.area_util_maxima),
      callback: function($$v) {
        _vm.form.area_util_maxima = $$v
      },
      expression: "form.area_util_maxima"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-3"
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Com calçada",
      "items": _vm.lista.com_calcada,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.com_calcada),
      callback: function($$v) {
        _vm.form.com_calcada = $$v
      },
      expression: "form.com_calcada"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Com muro",
      "items": _vm.lista.com_muro,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.com_muro),
      callback: function($$v) {
        _vm.form.com_muro = $$v
      },
      expression: "form.com_muro"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$hasGranularPermission('area', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "IPTU",
      "items": _vm.lista.iptu_condicao,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.iptu_condicao),
      callback: function($$v) {
        _vm.form.iptu_condicao = $$v
      },
      expression: "form.iptu_condicao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('valor', 'view')) ? _c('v-list-group', {
    attrs: {
      "no-action": ""
    },
    model: {
      value: (_vm.opcoes.valor),
      callback: function($$v) {
        _vm.opcoes.valor = $$v
      },
      expression: "opcoes.valor"
    }
  }, [(_vm.$hasGranularPermission('valor', 'view')) ? _c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Valor")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-flex', {
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('div', {
    staticClass: "body-2 pt-2"
  }, [_vm._v("Estimativa do valor (R$)")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "estimativa_valor_minimo",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.estimativa_valor_minimo),
      callback: function($$v) {
        _vm.form.estimativa_valor_minimo = $$v
      },
      expression: "form.estimativa_valor_minimo"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Mín.)")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "estimativa_valor_maximo",
      "hide-details": ""
    },
    on: {
      "input": _vm.marcarFiltroAlterado
    },
    model: {
      value: (_vm.form.estimativa_valor_maximo),
      callback: function($$v) {
        _vm.form.estimativa_valor_maximo = $$v
      },
      expression: "form.estimativa_valor_maximo"
    }
  }), _vm._v(" "), _c('small', [_vm._v("(Máx.)")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('valor', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('vistoria', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Vistoria",
      "items": _vm.lista.vistoria,
      "multiple": "",
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.vistoria),
      callback: function($$v) {
        _vm.form.vistoria = $$v
      },
      expression: "form.vistoria"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('vistoria', 'view')) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-select', {
    attrs: {
      "label": "Com tarefas pendentes",
      "items": _vm.lista.tarefas_pendentes,
      "hide-details": "",
      "no-data-text": "Sem opções disponíveis",
      "append-icon": "keyboard_arrow_right"
    },
    on: {
      "update:searchInput": _vm.closedSelect,
      "change": _vm.marcarFiltroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.openedSelect($event)
      }
    },
    model: {
      value: (_vm.form.tarefas_pendentes),
      callback: function($$v) {
        _vm.form.tarefas_pendentes = $$v
      },
      expression: "form.tarefas_pendentes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'view')) ? _c('v-divider') : _vm._e()], 1), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "width": "100%",
      "align-self": "flex-end"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "padding": "9px 16px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "remover_padding mx-0 grey",
    class: {
      'secondary--text': _vm.countFiltros > 0, 'grey--text': _vm.countFiltros === 0
    },
    attrs: {
      "flat": "",
      "disabled": _vm.countFiltros === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.limparFiltros($event)
      }
    }
  }, [_vm._v("Limpar filtros")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mr-0 grey grey--text",
    attrs: {
      "outline": "",
      "disabled": !_vm.filtroAlterado
    },
    nativeOn: {
      "click": function($event) {
        _vm.setFiltros($event)
      }
    }
  }, [_vm._v("Aplicar")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7018e04a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Template/TemplateLeftNav.vue
// module id = 1027
// module chunks = 1